export default {
  'storeConfig.title': 'Store Configuration',
  'storeConfig.form.shopName': 'Shop Name',
  'storeConfig.form.shopName.placeholder': 'Please select Shop Name',
  'storeConfig.form.ccConfig': 'Credit Card Config',
  'storeConfig.form.ccConfig.placeholder': 'Please select Credit Card Config',
  'storeConfig.form.scConfig': 'Renewal Credit Card Config',
  'storeConfig.form.scConfig.placeholder':
    'Please select Renewal Credit Card Config',
  'storeConfig.form.paypalConfig': 'PayPal Config',
  'storeConfig.form.paypalConfig.placeholder': 'Please select PayPal Config',
  'storeConfig.form.localPayment': 'Local Payment',
  'storeConfig.form.localPayment.placeholder': 'Please select Local Payment',
  'storeConfig.form.search': 'Query',
  'storeConfig.form.reset': 'Reset',
  'storeConfig.form.collapse': 'Collapse',
  'storeConfig.operation.attachPaymentProfile': 'Attach Payment Profile',
  'storeConfig.operation.detachPaymentProfile': 'Detach Payment Profile',
  'storeConfig.columns.index': 'Serial Number',
  'storeConfig.columns.merchantName': 'Merchant Name',
  'storeConfig.columns.shopName': 'Shop Name',
  'storeConfig.columns.shopifyId': 'Shopify ID',
  'storeConfig.columns.ccConfig': 'Credit Card Config',
  'storeConfig.columns.scConfig': 'Renewal Credit Card Config',
  'storeConfig.columns.paypalConfig': 'PayPal Config',
  'storeConfig.columns.localPayment': 'Local Payment',
  'storeConfig.columns.status': 'Status',
  'storeConfig.columns.remarks': 'Remarks',
  'storeConfig.status.enabled': 'Enabled',
  'storeConfig.status.disabled': 'Disabled',
  'storeConfig.none': 'None',
  'storeConfig.error.fetchFailed': 'Failed to fetch data',
  'storeConfig.error.noSelection': 'Please select data first',
  'storeConfig.error.fetchPaymentFailed': 'Failed to fetch payment list',
  'storeConfig.error.noMerchant': 'Merchant information not found',
  'storeConfig.error.multipleMerchants': 'Selected shops belong to different merchants, please select shops from the same merchant',
  'storeConfig.error.noPaymentSelected': 'Please select at least one payment profile',
  'storeConfig.error.attachPaymentFailed': 'Failed to attach payment profiles',
  'storeConfig.error.detachPaymentFailed': 'Failed to detach payment profiles',
  'storeConfig.error.noTypeSelected': 'Please select at least one type to detach',
  'storeConfig.success.attachPaymentProfile': 'Payment profiles attached successfully',
  'storeConfig.success.detachPaymentProfile': 'Payment profiles detached successfully',
  'storeConfig.modal.attachPaymentProfile': 'Attach Payment Profiles',
  'storeConfig.modal.detachPaymentProfile': 'Detach Payment Profiles',
  'storeConfig.modal.cardConfig': 'Credit Card Config',
  'storeConfig.modal.scConfig': 'Renewal Credit Card Config',
  'storeConfig.modal.paypalConfig': 'PayPal Config',
  'storeConfig.modal.localPayment': 'Local Payment',
  'storeConfig.modal.selectPlaceholder': 'Please select payment profile',
  'storeConfig.modal.selectTypes': 'Select types to detach',
  'storeConfig.modal.detachWarning': 'All [{types}] in the {count} selected shop(s) will be detached',
};
